export default {
    locale: 'en-GB',
    dismissAlertText: 'Close'
};
